/**
 * Account > Notifications (2026-10-21, gift send flow FINAL.md §3): the one
 * line under the Email tick (was "Email me when something arrives"), from the server's state
 * ({ on, locked, reason, since, source }). Off by the switch itself says
 * nothing (they just did it); off from an email says when; an address whose
 * mail does not arrive points to the Email field.
 */
export function maskEmail (address) {
  const v = (address || '').trim()
  const at = v.indexOf('@')
  return at > 0 ? `${v[0]}•••${v.slice(at)}` : ''
}

function day (iso) {
  if (!iso) return ''
  const d = new Date(iso)
  if (isNaN(d.getTime())) return ''
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

export function notificationNote (state, email) {
  const s = state || {}
  // No email on the account (made by phone): why the Email tick waits.
  if (s.reason === 'no_address') return 'Add your email above to get these by email.'
  if (s.reason === 'undeliverable') {
    const masked = maskEmail(email)
    return `Emails to ${masked || 'your address'} aren't arriving. Check the address above, then save it.`
  }
  if (s.reason === 'opted_out' && (s.source === 'link' || s.source === 'post')) {
    const when = day(s.since)
    return `You turned these off from an email${when ? ` on ${when}` : ''}. Tick Email to get them again.`
  }
  return ''
}
